import AdresseVille from '@/generated/controls/adresse/AdresseVille.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: AdresseVille
})
